<template>
  <div class="wrapper-acquisition">
    <div class="row">
      <div class="col-12">
        <div class="gate-logo">
          <img src="/img/akusisiuser/logomasjid.svg" />
        </div>
        <p class="text-center welcome">
          Assalamu'alaikum {{ this.fullname ? this.fullname : '. . .'
          }}<br />
          Berikut adalah Jumlah <strong>Penerima Manfaat</strong>
          <br />yang telah Anda daftarkan.
        </p>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-6">
        <div
          class="summary"
          @click="goToList('akusisi-user-dkm-list')"
        >
          <div class="summary-box">
            <!-- <img class="icon-role" src="/img/icons/icon_dkm.svg" /> -->
            <img
              class="icon-role"
              src="/img/akusisiuser/masjid.svg"
            />
          </div>
          <div class="summary-title">
            <span class="count">{{ summary.masjid }}</span> <br />
            <span class="label">
              Masjid
            </span>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div
          class="summary"
          @click="goToList('akusisi-user-ustad-list')"
        >
          <div class="summary-box">
            <img class="icon-role" src="/img/akusisiuser/ustad.svg" />
            <!-- <img class="icon-role" src="/img/icons/icon_ustad.svg" /> -->
          </div>
          <div class="summary-title">
            <span class="count">{{ summary.ustad }}</span> <br />
            <span class="label">
              Ustad
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-6">
        <div
          class="summary"
          @click="goToList('akusisi-user-relawan-list')"
        >
          <div class="summary-box">
            <img
              class="icon-role"
              src="/img/akusisiuser/relawan.svg"
            />

            <!-- <img
              class="icon-role"
              src="/img/icons/icon_relawan.svg"
            /> -->
          </div>
          <div class="summary-title">
            <span class="count">{{ summary.relawan }}</span> <br />
            <span class="label">
              Relawan
            </span>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div
          class="summary"
          @click="goToList('akusisi-user-yatimdhuafa-list')"
        >
          <div class="summary-box">
            <!-- <img
              class="icon-role"
              src="/img/icons/icon_yatimdhuafa.svg"
            /> -->
            <img
              class="icon-role"
              src="/img/akusisiuser/jamaah.svg"
            />
          </div>
          <div class="summary-title">
            <span class="count">{{ summary.yatimdhuafa }}</span>
            <br />
            <span class="label">
              Dhuafa / Yatim
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div style="display:flex; gap: 15px;">
        <a
          href="javascript:void(0)"
          class="btn btn-main btn-daftarkan"
          @click="daftarkan()"
        >
          Daftarkan
        </a>
        <a
          href="javascript:void(0)"
          class="btn btn-main btn-daftarkan"
          @click="upgrade()"
        >
          Upgrade
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/utils/masjedapi';

export default {
  data() {
    return {
      reff_code: '',
      fullname: '',
      summary: {
        yatimdhuafa: 0,
        ustad: 0,
        relawan: 0,
        masjid: 0,
      },
    };
  },
  mounted() {
    this.reff_code = this.$route.params.ref_code;
    this.loadSummary();
  },
  methods: {
    async loadSummary() {
      const sources = await axios.get(
        `/akusisi/summary-cek/${this.reff_code}`
      );
      const { data } = sources.data;
      console.log(data);
      this.summary = data.summary;
      this.fullname = data.fullname;
    },
    daftarkan() {
      this.$router.push({
        name: 'akusisi-user-gate',
        params: { ref_code: this.reff_code },
      });
    },
    upgrade() {
      this.$router.push({
        name: 'upgrade-user-dkm',
        params: { ref_code: this.reff_code },
      });
    },
    goToList(name) {
      this.$router.push({
        name: name,
        params: { ref_code: this.reff_code },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.summary {
  text-align: center;
  cursor: pointer;
  .summary-box {
    display: flex;
    margin: 0 auto;
    border: 1px solid #ddd;
    border-radius: 5px;
    height: 100px;
    width: 100px;
    align-items: center;
    justify-content: center;
    img {
      height: 85px;
      width: 85px;
    }
  }

  .summary-title {
    font-weight: bold;
    padding: 10px 0px;
    color: #555;

    .count {
      font-size: 25px;
    }

    .label {
      font-size: 13px;
    }
  }
}

.welcome {
  border-bottom: 1px dotted #ccc;
  padding: 0px 0px 10px 0px;
  color: #555;
  font-size: 13px;
  line-height: 20px;
}

.btn-daftarkan {
  display: block;
  margin: 0 auto;
  font-size: 13px;
  width: 50%;
  border-radius: 5px !important;
  background: #ff8823 !important;

  &:hover {
    background: #e67a20 !important;
  }
}
</style>
